module.exports = __webpack_public_path__ + "img/profile-icon-bg-blue.da5679b6.svg";